jQuery(document).on('ready', function(){
	RATING.onReady();
});




var RATING = {
	onReady : function(){
		if ( jQuery('.rating').length < 1 )
			return;

		// RATING.initForm();
		jQuery(document).on('mouseenter', '.rating .star', RATING.mouseenterRating);
		jQuery(document).on('mouseleave', '.rating .star', RATING.mouseleaveRating);
		jQuery(document).on('click', '.rating .star', RATING.clickRating);
		// jQuery(document).on('click', '.ratings.active.rating-active span', RATING.submitRating);
	},



	mouseenterRating : function(){
		let context = jQuery(this).parent();
		RATING.index = jQuery(this).index();

		jQuery('.star .fill', context).hide();
		jQuery('.star .blank', context).hide();

		jQuery.each(jQuery('.star', context), function(i,v){
			if(i <= RATING.index){
				jQuery('.fill', v).show();
			} else {
				jQuery('.blank', v).show();
			}

		});
	},


	mouseleaveRating : function(){
		let context = jQuery(this).parent();
		jQuery('.star .fill', context).hide();
		jQuery('.star .blank', context).show();

		if(RATING.clicked == true)
			RATING.markRating();
	},



	markRating : function(){
		RATING.index = jQuery('input.radio-rating:checked').val();

		jQuery.each(jQuery('.rating .star'), function(i,v){
			if(i <= RATING.index){
				jQuery('.fill', v).show();
			} else {
				jQuery('.blank', v).show();
			}
		});
	},



	clickRating : function(){
		RATING.context = jQuery(this).closest('.rating');
		RATING.postid = jQuery(RATING.context).attr('data-postid');
		RATING.clicked = true;
		RATING.index = jQuery(this).index();
		
		console.log(RATING.context);
		console.log(RATING.postid);
		console.log('input.radio-rating-' + RATING.index);
		
		
		
		jQuery('input.radio-rating', RATING.context).prop('checked', false);
		jQuery('input.radio-rating-' + RATING.index, RATING.context).prop('checked', true);
		
		RATING.submitRating();
	},



	submitRating : function(){
		jQuery.ajax({
            url: kdkJS.ajaxurl,
            type:'POST',
            data: "action=set_rating&rating=" + RATING.index + '&postid=' + RATING.postid, 
            success: function(response){
            	var regex    = new RegExp(/[0]$/);
				var response = response.replace(regex, '');

            	jQuery('.alert', RATING.context).remove();

            	RATING.context.append('<div class="alert is-size-7"><i>' + response + '</i></div>');

            	jQuery('.alert', RATING.context).fadeIn(function(){
            		setTimeout(() => {
            			jQuery('.alert', RATING.context).fadeOut();
            		}, 2000)
            	});
            },
            error : function(jqXHR, textStatus, errorThrown){
                console.log('AJAX Error: ' + textStatus + ' ' + errorThrown);
            }
        });
		// alert("action=set_rating&rating=" + RATING.index + '&postid=' + RATING.postid);
	}
}